import { IFaqSectionTileIcon } from '@adscore/adscore-frontend-common';
import { NgIf } from '@angular/common';
import { Component, ChangeDetectionStrategy, Input } from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { AdscoreMinModule } from 'adscore/adscore-min.module';

@Component({
  standalone: true,
  selector: 'app-section-tile',
  templateUrl: './section-tile.component.html',
  styleUrls: ['./section-tile.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [AdscoreMinModule, NgIf, FontAwesomeModule]
})
export class SectionTileComponent {
  @Input() section: {
    icon: IFaqSectionTileIcon;
    id?: string;
    title?: string;
    subtitle?: string;
    alignToTop?: boolean;
  };
}
